export default __webpack_public_path__ + "static/media/stamp.43f4e67f.png";